import React from 'react';

export default function () {
  return (
    <>
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-s1">
          <stop stopColor="#D84438" offset="0%" />
          <stop stopColor="#66120E" offset="100%" />
        </linearGradient>
      </defs>
      <g id="Slightly" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M116.712747,135 C99.7500923,135 86,150.199408 86,168.966406 L86,268.032778 C86,286.785081 99.7500923,302 116.712747,302 L121.287253,302 C138.249908,302 152,286.792429 152,268.033594 L152,168.966406 C152,150.206755 138.24917,135 121.287253,135 L116.712747,135 Z"
          id="Path"
          fill="#D6D6D6"
          fillRule="nonzero"
        />
        <path
          d="M202.713091,302 L207.286909,302 C224.249754,302 238,286.834163 238,268.126809 L238,112.873191 C238,94.173164 224.249016,79 207.286909,79 L202.713091,79 C185.750246,79 172,94.1658367 172,112.873191 L172,268.126809 C171.999262,286.826836 185.750246,302 202.713091,302 Z"
          id="Path"
          fill="#D6D6D6"
          fillRule="nonzero"
        />
        <path
          d="M324,268.130856 L324,33.8691437 C324,15.171351 310.249323,0 293.286858,0 L288.706498,0 C271.750677,0 258,15.1640246 258,33.8691437 L258,268.130042 C258,286.827835 271.750677,302 288.706498,302 L293.286858,302 C310.249323,302 324,286.835975 324,268.130856 Z"
          id="Path"
          fill="#D6D6D6"
          fillRule="nonzero"
        />
        <path
          d="M35.2899496,176 L30.7159552,176 C13.7559355,176 0,191.154983 0,209.849763 L0,268.150237 C0,286.837695 13.7559355,302 30.7166933,302 L35.2906877,302 C52.2440645,302 66,286.845017 66,268.151051 L66,209.849763 C66,191.154983 52.2440645,176 35.2899496,176 Z"
          id="Path"
          fill="url(#linearGradient-s1)"
          fillRule="nonzero"
        />
      </g>
    </>
  );
}
